import React from "react";
import { T } from "./Translate";
import { Box, Container } from "@mui/material";
import BottomToolbar from "./BottomToolbar";
import PageHeader from "./PageHeader";
import { pageContentSx } from "../pageLayout";

const Refunds = () => {
  return (
    <Container maxWidth={false} disableGutters sx={pageContentSx}>
      <PageHeader title={<T>Política de Reembolsos</T>} />

      <Container sx={{ mt: "16px", mb: 16 }}>
        <Container
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            width: "100%",
            textAlign: "left",
          }}
        >
          <Box>
            <h1><T>Política de Reembolsos de Notiline</T></h1>

            <p>
              <T>En Notiline queremos que estés conforme con tu suscripción. Esta política
              explica en qué casos aplica un reembolso, cómo solicitarlo y en qué plazos
              lo procesamos.</T>
            </p>

            <h2><T>Reembolso en los primeros 7 días</T></h2>
            <p>
              <T>Si acabas de suscribirte, puedes pedir el reembolso completo dentro de los
              primeros 7 días desde la activación, siempre que no hayas usado las funciones
              de publicación de forma extensiva (por ejemplo, no hayas alcanzado el límite
              de publicaciones de tu plan).</T>
            </p>

            <h2><T>Fallas del servicio y renovaciones no deseadas</T></h2>
            <p>
              <T>También aplican reembolsos cuando el motivo del reclamo es una falla del
              servicio de Notiline, un cobro duplicado, o una renovación automática que no
              deseabas y que reportas dentro de un plazo razonable luego del cargo.</T>
            </p>

            <h2><T>Qué no cubre esta política</T></h2>
            <p>
              <T>No se emiten reembolsos por períodos ya utilizados fuera de la ventana de 7
              días, ni por cuentas suspendidas o dadas de baja por incumplir los Términos y
              Condiciones de la app.</T>
            </p>

            <h2><T>Cómo solicitar un reembolso</T></h2>
            <p>
              <T>Escríbenos a support@notiline.com o desde la sección de Soporte de la app,
              indicando tu nombre, correo, ID de suscripción, fecha del cargo y el motivo de
              tu solicitud. Revisamos las solicitudes en un plazo de 5 días hábiles y te
              avisamos por correo el resultado.</T>
            </p>

            <h2><T>Procesamiento a través de PayPal</T></h2>
            <p>
              <T>Los pagos de suscripción se procesan a través de PayPal. Cuando aprobamos un
              reembolso, PayPal lo acredita al mismo método de pago utilizado para el cargo
              original; el tiempo exacto de acreditación depende de PayPal y de tu banco o
              tarjeta.</T>
            </p>

            <h2><T>Cancelar tu suscripción</T></h2>
            <p>
              <T>Cancelar tu suscripción desde la sección "Suscripción" detiene los cargos
              futuros (autopay) pero no genera, por sí sola, un reembolso automático del
              período ya facturado: seguís con tu plan hasta que ese período termine. Si querés además un reembolso de ese período, seguí los
              pasos de la sección anterior.</T>
            </p>

            <h2><T>Pedidos de comida y súper</T></h2>
            <p>
              <T>Los pedidos se pagan en efectivo o por transferencia directamente al local, así
              que Notiline no recibe ese dinero y no puede reembolsarlo. Esta política no cubre
              esos pagos: cada local responde por sus productos, entregas y devoluciones.</T>
            </p>
            <ul>
              <li><T>Puedes cancelar el pedido desde su detalle mientras el local no lo haya aceptado.</T></li>
              <li><T>Si ya transferiste y el pedido se canceló, fue rechazado, no llegó o tuvo un problema, pídele la devolución directamente al local.</T></li>
              <li><T>Si el local no responde, escríbenos a support@notiline.com indicando el local y la fecha del pedido. Podemos revisar la conducta del local, pero no garantizamos la devolución del dinero.</T></li>
            </ul>
            <p>
              <T>Nada de esto limita los derechos que te reconozca la ley de tu país como
              consumidor. La suscripción que paga un local para estar en Pedidos sí se rige por
              el resto de esta política.</T>
            </p>

            <h2><T>Contacto</T></h2>
            <p>
              <T>Ante cualquier duda sobre esta política, escribinos a support@notiline.com.</T>
            </p>
          </Box>
        </Container>
      </Container>
      <BottomToolbar />
    </Container>
  );
};

export default Refunds;
